<template>
  <div class="settings">
    <VPBreadcrumbs :elements="[{ text: 'Team', to: parentRoute }, { text: 'New team member' }]" />

    <Form
      :form-id="formId"
      :initial-values="User.getNew()"
    >
      <UserAccountFields />

      <FormActionButtons
        :show-save="isFormDirty()"
        :show-cancel="isFormDirty()"
        @save="handleSave"
        @cancel="onCancel"
      />
    </Form>
  </div>
</template>

<script setup lang="ts">
import { useUserAccountsStore } from '@/stores/user-accounts';
import UserAccountFields from './UserAccountFields.vue';
import { Form, useFormsStoreComposable } from 'vuniform';
import { useRootStore } from '@/stores/root';
import { useToast } from 'vue-toastification';
import { useRouter } from 'vue-router';
import type { SaveUserAccountMutationInput, UserAccountAttributes } from '../../generated/graphql';
import * as User from '@/types/User';
import VPBreadcrumbs from '@/components/VPBreadcrumbs.vue';
import FormActionButtons from '@/components/form/FormActionButtons.vue';

const userAccountStore = useUserAccountsStore();
const toast = useToast();
const router = useRouter();
const rootStore = useRootStore();
const parentRoute = { name: 'UserAccountIndex' };
const { formId, formsStore, formGetValues, isFormDirty } = useFormsStoreComposable('new-user-account-form');

const handleSave = async () => {
  const values = formGetValues<UserAccountAttributes>();
  const payload: SaveUserAccountMutationInput = {
    clientMutationId: formId,
    userAccount: {
      ...values,
      accountId: rootStore.currentAccountId,
    },
  };
  const { result: newUserAccount, errors } = await userAccountStore.saveUser(payload);

  if (errors) {
    formsStore.SET_ERRORS({ requesterId: formId, errors });
    return;
  }

  if (!newUserAccount) {
    return;
  }

  toast.success('User account created successfully!');
  router.push(parentRoute);
};

const onCancel = () => formsStore.RESET_FIELD_VALUES(formId);
</script>
